module.exports = __webpack_public_path__ + "static/media/26.2d016175.jpg";